/*
  We create and scan work information items based on these questions. As we scan work
  information items for these questions, it's important that the answers to these questions
  do not contain the questions.
*/


// NOTE: #neverEditOrDeleteBizJust
// If these scanned business justififcations ever change, we CANNOT just change the string.
// We need to keep track of historic ones so we can scan existing work information items.
// As such, if the questions do change, please just add another question to the list of
// scanned questions. You can change variable names though. ie "oldBizJustA " or
// something. Providing you make sure to add it to the correct scannedBixJust list



const currentBizJustA = 'What is the urgent need for submitting this change as expedited?'; // #neverEditOrDeleteBizJust

const currentBizJustB = 'Why was this change not raised earlier?'; // #neverEditOrDeleteBizJust

const currentBizJustC = 'If this change is rescheduled in line with its normal SLA, what is the extra impact to the business or customers?'; // #neverEditOrDeleteBizJust

const bizJustATitle = currentBizJustA;
const bizJustBTitle = currentBizJustB;
const bizJustCTitle = currentBizJustC;


const scannedBizJustA = [
  currentBizJustA,
];

const scannedBizJustB = [
  currentBizJustB,
];

const scannedBizJustC = [
  currentBizJustC,
];



const scannedBizJusts = [
  ...scannedBizJustA,
  ...scannedBizJustB,
  ...scannedBizJustC,
];

const findQuestionsInValue = (value) => {

  if (!value) {
    return null;
  }

  const questionsFound = [];

  scannedBizJusts.forEach((bizJust) => {
    const questionFound = value.includes(bizJust);

    if (questionFound) {
      questionsFound.push(bizJust);
      return null;
    }

    return null;
  });

  if (questionsFound.length > 0) {
    return `Answer cannot include: ${questionsFound.join(', ')}`;
  }
  return null;
};


// FN: 05/05/2020
// if getBizJustQABase is changed then we will no longer be able to correctly scan historic business justification
// work information items. If it is vital that we edit getBizJustQABase, please refactor "unpackBusinessJustification"
// found in "work-info-item-utils.js" so that it can handle both old and new getBizJustQABases
const getBizJustQABase = (question, questionNumber) => `Q${questionNumber}. ${question}\nA${questionNumber}. `;
const bizJustQAJoiner = '\n\n';

const bizJustAFieldId = 'business-justification-a';
const bizJustBFieldId = 'business-justification-b';
const bizJustCFieldId = 'business-justification-c';


export {
  scannedBizJustA,
  scannedBizJustB,
  scannedBizJustC,
  scannedBizJusts,
  findQuestionsInValue,
  bizJustATitle,
  bizJustBTitle,
  bizJustCTitle,
  getBizJustQABase,
  bizJustQAJoiner,
  bizJustAFieldId,
  bizJustBFieldId,
  bizJustCFieldId,
};

